// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
  MDBBtn, MDBCol, MDBIcon, MDBModal, MDBModalBody, MDBRow,
} from 'mdbreact';
import { connect } from 'react-redux';
import Notification from '../notification';
import { unAssignWorkOrder } from '../../storage/actions/workOrdersActions';
import { toggleModal, toggleSecondModalClose } from '../../storage/actions/modalsActions';

const UnAssignModal = ({
  modalState,
  unAssignWorkOrder,
  toggleSecondModalClose,
}) => {
  const submitUnAssign = (event) => {
    event.preventDefault();
    if (!event.target.message.value.trim() || !modalState.type) {
      Notification('warning', { message: 'Please enter valid reason to unassign the contractor.' });
    } else {
      unAssignWorkOrder({
        ...modalState.type,
        reason: event.target.message.value,
      });
    }
  };

  return (
    <>
      <div className={`modal_block dashboard-modal dashboard-modal--centered modal_import ${modalState.isOpen ? 'showed' : ''}`}>
        <div className="modal_container " style={{ minHeight: 'fit-content' }}>
          <div className="modal_head">
            <div className="modal_title">Unassign Contractor</div>
            <button
              type="button"
              className="close_btn icon_close"
              aria-label="close"
              onClick={() => {
                toggleSecondModalClose('unAssignModal', true);
              }}

            />
          </div>
          <div className="modal_body">
            <div className="info_block">
              <div className="block_sub">

              </div>
            </div>
            <form onSubmit={submitUnAssign}>
              <MDBCol md="12">
                <div className="form-group signinput">
                  <label htmlFor="formGroupExampleInput" className="font12">
                    Reason to unassign contractor
                    <label style={{ fontWeight: 'bold' }}>
                      (This message will be sent to the contractor)
                    </label>
                  </label>
                  <div className="field_block">
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      id="reason_to_unassign"
                      name="message"
                      required
                    />
                  </div>

                </div>
              </MDBCol>
              <br />

              <button className="standard_btn dark_btn" aria-label="search" type="submit">Submit</button>

            </form>
          </div>
        </div>
      </div>

    </>

  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.unAssignModal,
});

export default connect(mapStateToProps, { toggleModal, toggleSecondModalClose, unAssignWorkOrder })(UnAssignModal);
